const PageHeader = ({children}) => {
    return(
        <h3 className="font-[700] capitalize lg:text-3xl md:text-2xl text-xl leading-[36.9px] tracking-[-2%] text-[#0d0f11]">
            {children}
        </h3>
    )
}

export default PageHeader;